export function buildLink(url: string) {
  url = decodeURIComponent(url)

  return !/^(?:f|ht)tps?\:\/\//.test(url) ? `https://${url}` : url
}
